module.exports = __webpack_public_path__ + "static/img/product2.ada88335.png";